import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, Grid, Hidden, LinearProgress, Button } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { useHistory } from 'react-router';
import { Formik, FormikHelpers, validateYupSchema, yupToFormErrors } from 'formik';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { DatePicker } from '../../lib/formik/DatePicker';
import { useDispatch } from 'react-redux';
import { SubHeading } from '../investors/components';
import MFSelectField from '../../lib/formik/SelectField';
import { getFundManagersList, getTrustessList } from '../../redux-store/actions/userManagement';
import { FundManager, Trustee } from '../../redux-store/types/api-types';
import {
  addFund,
  addPlan,
  fundAccess,
  getPlanList,
  updateFund,
} from '../../redux-store/actions/funds';
import { Location } from 'history';
import {
  accessType,
  addFundPlanType,
  ClassPlanProps,
  FundProps,
  SipInvestmentModeProp,
} from '../../redux-store/types/funds';
import { addFundValidation, editFundValidation } from '../../utils/schema';
import {
  allowOnlyNumbers,
  currencyConversion,
  isFieldApplicable,
  isFieldVariable,
} from '../../utils/utilityFunctions';
import {
  CurrencyMaster,
  FEE_TYPE_MASTER,
  INVESTMENT_METHOD_MASTER,
  IS_STAMP_PAPER_SERIES_MASTER,
  YES_NO_MASTER,
  defaultCurrency,
} from '../../utils/constant';
import UseRadioGroup from '../../lib/formik/Radio';
import { styles } from '../../Styles/styles';
import { MultipleSelect } from '../../lib/formik/MultipleSelectField';
import { InvestmentCategoryHeading } from './fundDetail';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { ConfirmationDialog } from '../commonComponents';
import MFCheckbox from '../../lib/formik/Checkbox';

const newSipDetails = { percentage: '', months: '', sno: 0 };

const initialValues: addFundPlanType = {
  planClass: null,
  schemeCode: '',
  schemeName: '',
  amcCode: '',
  bankName: '',
  bankBranch: '',
  ifscCode: '',
  bankAccountNumber: '',
  id: '',
  schemeId: null,
  planCode: '',
  planDescription: '',
  schemeNature: '',
  registrationNumber: '',
  schemeCategory: '',
  country: '',
  currency: defaultCurrency,
  schemeStartDate: `${new Date()}`,
  lockInPeriod: '',
  lockInExtension: '',
  inActive: true,
  faceValue: 0,
  fundAddress1: '',
  fundAddress2: '',
  fundAddress3: '',
  isActive: true,
  custodian: '',
  setupFee: 0,
  fundManagerId: null,
  trusteeId: null,
  minCommitmentAmount: null,
  maxCommitmentAmount: 0,
  minContributionPercentage: 0,
  managementFee: 0,
  tcLink: '',
  LEEGALITY_STAMP_SERIES: '',
  LEEGALITY_STAMP_SERIES_GROUP: '',
  LEEGALITY_STAMP_VALUE: null,
  LEEGALITY_USE_STAMP_SERIES: null,
  modeOfInvestment: [],
  lumpsumDetails: { percentage: '100' },
  sipDetails: [newSipDetails],
  drawdownDetails: { percentage: '' },
  classOfUnits: '',
  isApplicableForDirect: false,
  isApplicableForDistributor: false,
  hurdleRateApplicable: '',
  hurdleRateType: '',
  defaultHurdleRate: null,
  minHurdleRate: null,
  maxHurdleRate: null,
  performanceFeeApplicable: '',
  performanceFeeType: '',
  defaultPerformanceFee: null,
  minPerformanceFee: null,
  maxPerformanceFee: null,
};

export const checkDrawdown = (investmentCategory: string[] | null): boolean => {
  return !!(
    investmentCategory &&
    investmentCategory.length > 0 &&
    investmentCategory.find(
      (_category) => INVESTMENT_METHOD_MASTER[_category] === INVESTMENT_METHOD_MASTER.drawdown
    )
  );
};

export const checkSip = (investmentCategory: string[] | null): boolean => {
  return !!(
    investmentCategory &&
    investmentCategory.length > 0 &&
    investmentCategory.find(
      (_category) => INVESTMENT_METHOD_MASTER[_category] === INVESTMENT_METHOD_MASTER.sip
    )
  );
};

export const checkLumpsum = (investmentCategory: string[] | null): boolean => {
  return !!(
    investmentCategory &&
    investmentCategory.length > 0 &&
    investmentCategory.find(
      (_category) => INVESTMENT_METHOD_MASTER[_category] === INVESTMENT_METHOD_MASTER.lumpsum
    )
  );
};

export const SIPDetails = ({
  values,
  setValues,
}: {
  values: addFundPlanType;
  setValues: FormikHelpers<addFundPlanType>['setValues'];
}): JSX.Element => {
  const [removeSip, SetRemoveSip] = useState<null | number>(null);
  const AddSip = async () => {
    setValues({
      ...values,
      sipDetails: values?.sipDetails?.concat(newSipDetails)?.map((item, i) => {
        return { ...item, sno: i };
      }) as SipInvestmentModeProp[],
    });
    return;
  };
  const RemoveSip = (sno: number) => {
    setValues({
      ...values,
      sipDetails: values?.sipDetails
        ?.filter((item) => item.sno !== sno)
        ?.map((item, i) => {
          return { ...item, sno: i };
        }) as SipInvestmentModeProp[],
    });
    return;
  };
  return (
    <>
      {values?.sipDetails?.map((item, i) => (
        <React.Fragment key={i}>
          <Grid container rowSpacing={1} xs={12} sm={12} columnSpacing={4} pr={2} pl={4}>
            <Grid item xs={12} sm={6} md={4}>
              <MFTextField
                name={`sipDetails.${i}.percentage`}
                label="Percentage *"
                placeholder="Enter Percentage"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} display={'flex'} direction={'row'}>
              <MFTextField
                name={`sipDetails.${i}.months`}
                label="Months *"
                placeholder="Enter Months"
              />

              {values?.sipDetails?.length !== 1 && i !== 0 && (
                <>
                  {i + 1 === values?.sipDetails?.length && (
                    <AddIcon
                      onClick={AddSip}
                      sx={{
                        mt: 7,
                        color: 'rgba(0,0,0,0.7)',
                        ':hover': { cursor: 'pointer' },
                      }}
                    />
                  )}

                  <RemoveIcon
                    onClick={() => SetRemoveSip(item.sno)}
                    sx={{
                      mt: 7,
                      color: 'rgba(0,0,0,0.7)',
                      ':hover': { cursor: 'pointer' },
                    }}
                  />
                </>
              )}
            </Grid>
          </Grid>
        </React.Fragment>
      ))}
      {values?.sipDetails?.length === 1 && (
        <Grid item xs={12}>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            sx={{
              color: 'primary.main',
              fontWeight: 500,
              fontSize: 14,
              mt: 2,
            }}
            onClick={AddSip}>
            Add SIP
          </Button>
        </Grid>
      )}
      <ConfirmationDialog
        message={`Are you sure you want to delete?`}
        open={removeSip !== null}
        setOpen={() => SetRemoveSip(null)}
        onSave={async () => {
          SetRemoveSip(null);
          RemoveSip(removeSip as number);
        }}
        onCancel={() => SetRemoveSip(null)}
      />
    </>
  );
};

export default function AddFund({
  location,
}: {
  location: Location<{ fundId: number }>;
}): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const [fundManager, setFundManager] = useState<any[]>([]);
  const [editField, setEditField] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const { fundId } = location.state || {};
  const [access, setAccess] = useState(false);
  const [trustee, setTrustee] = useState<any[]>([]);

  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        setLoading(true);
        const trusteeList = (await dispatch(
          getTrustessList({ isActive: true })
        )) as unknown as Trustee[];
        const fundManagerList = (await dispatch(
          getFundManagersList({ isActive: true })
        )) as unknown as FundManager[];
        const { fundSetupAccess } = (await dispatch(fundAccess())) as unknown as accessType;
        setAccess(fundSetupAccess);
        setFundManager(fundManagerList);
        setTrustee(trusteeList);

        if (fundId) {
          const GetFundDetail = (await dispatch(
            getPlanList(fundId.toString())
          )) as unknown as FundProps;
          const {
            schemeCode,
            schemeName,
            amcCode,
            bankName,
            bankBranch,
            ifscCode,
            bankAccountNumber,
            LEEGALITY_STAMP_SERIES = '',
            LEEGALITY_STAMP_SERIES_GROUP = '',
            LEEGALITY_STAMP_VALUE = null,
            // LEEGALITY_USE_STAMP_SERIES = null,
            modeOfInvestment = [],
            lumpsumDetails = null,
            drawdownDetails = null,
            sipDetails = null,
          } = GetFundDetail || {};

          setEditField({
            ...editField,
            schemeCode,
            schemeName,
            amcCode,
            bankName,
            bankBranch,
            ifscCode,
            bankAccountNumber,
            LEEGALITY_STAMP_SERIES,
            LEEGALITY_STAMP_SERIES_GROUP,
            LEEGALITY_STAMP_VALUE,
            // LEEGALITY_USE_STAMP_SERIES: LEEGALITY_USE_STAMP_SERIES || false,
            modeOfInvestment: modeOfInvestment?.length ? modeOfInvestment : [],
            lumpsumDetails: lumpsumDetails || initialValues.lumpsumDetails,
            drawdownDetails: drawdownDetails || initialValues.drawdownDetails,
            sipDetails: sipDetails?.length ? sipDetails : initialValues.sipDetails,
          });
        }
        if (!isComponentAlive) return;
        setLoading(false);
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        if (isComponentAlive) {
          setLoading(false);
        }
      }
    })();
    return () => {
      isComponentAlive = false;
    };
  }, []);

  const onSubmit = async (values: addFundPlanType) => {
    try {
      const {
        schemeCode,
        schemeName,
        amcCode,
        bankName,
        bankBranch,
        ifscCode,
        bankAccountNumber,
        modeOfInvestment,
        lumpsumDetails,
        drawdownDetails,
        sipDetails,
      } = values;

      const {
        planCode,
        planDescription,
        schemeNature,
        registrationNumber,
        schemeCategory,
        country,
        currency,
        schemeStartDate,
        lockInPeriod,
        lockInExtension,
        inActive,
        faceValue,
        fundAddress1,
        fundAddress2,
        fundAddress3,
        isActive,
        custodian,
        setupFee,
        minCommitmentAmount,
        maxCommitmentAmount,
        minContributionPercentage,
        managementFee,
        fundManagerId,
        trusteeId,
        planClass,
        tcLink,
        LEEGALITY_STAMP_SERIES = '',
        LEEGALITY_STAMP_SERIES_GROUP = '',
        LEEGALITY_STAMP_VALUE = null,
        // LEEGALITY_USE_STAMP_SERIES = null,
        classOfUnits,
        isApplicableForDirect = false,
        isApplicableForDistributor = false,
        hurdleRateApplicable = '',
        hurdleRateType = '',
        defaultHurdleRate = null,
        minHurdleRate = null,
        maxHurdleRate = null,
        performanceFeeApplicable = '',
        performanceFeeType = '',
        defaultPerformanceFee = null,
        minPerformanceFee = null,
        maxPerformanceFee = null,
      } = values;
      const fundAdditionalObj = {
        lumpsumDetails: checkLumpsum(modeOfInvestment) ? lumpsumDetails : null,
        drawdownDetails: checkDrawdown(modeOfInvestment) ? drawdownDetails : null,
        sipDetails: checkSip(modeOfInvestment) ? sipDetails : null,
      };
      if (fundId) {
        await dispatch(
          updateFund(fundId, {
            schemeCode,
            schemeName,
            amcCode,
            bankName,
            bankBranch,
            ifscCode,
            bankAccountNumber,
            LEEGALITY_STAMP_SERIES,
            LEEGALITY_STAMP_SERIES_GROUP,
            LEEGALITY_STAMP_VALUE,
            LEEGALITY_USE_STAMP_SERIES: false,
            // LEEGALITY_USE_STAMP_SERIES?.toString() === 'true' ? true : false,
            modeOfInvestment,
            ...fundAdditionalObj,
          })
        );
      } else {
        const fundRes = (await dispatch(
          addFund({
            schemeCode,
            schemeName,
            amcCode,
            bankName,
            bankBranch,
            ifscCode,
            bankAccountNumber,
            LEEGALITY_STAMP_SERIES,
            LEEGALITY_STAMP_SERIES_GROUP,
            LEEGALITY_STAMP_VALUE,
            LEEGALITY_USE_STAMP_SERIES: false,
            // LEEGALITY_USE_STAMP_SERIES?.toString() === 'true' ? true : false,
            modeOfInvestment,
            ...fundAdditionalObj,
          })
        )) as unknown as FundProps;

        await dispatch(
          addPlan({
            schemeId: fundRes.id,
            planCode,
            planDescription,
            schemeNature,
            registrationNumber,
            schemeCategory,
            country,
            currency,
            schemeStartDate,
            lockInPeriod,
            lockInExtension,
            fundManagerId,
            trusteeId,
            planClass,
            inActive,
            faceValue,
            fundAddress1,
            fundAddress2,
            fundAddress3,
            isActive,
            custodian,
            setupFee: setupFee ? setupFee : 0,
            minCommitmentAmount,
            maxCommitmentAmount,
            minContributionPercentage: minContributionPercentage ? minContributionPercentage : 0,
            managementFee: managementFee ? managementFee : 0,
            tcLink,
            classOfUnits,
            isApplicableForDirect,
            isApplicableForDistributor,
            hurdleRateApplicable,
            defaultHurdleRate: isFieldApplicable(hurdleRateApplicable) ? defaultHurdleRate : null,
            hurdleRateType: isFieldApplicable(hurdleRateApplicable) ? hurdleRateType : null,
            maxHurdleRate: isFieldVariable(hurdleRateType, hurdleRateApplicable)
              ? maxHurdleRate
              : null,
            minHurdleRate: isFieldVariable(hurdleRateType, hurdleRateApplicable)
              ? minHurdleRate
              : null,
            performanceFeeApplicable,
            defaultPerformanceFee: isFieldApplicable(performanceFeeApplicable)
              ? defaultPerformanceFee
              : null,
            performanceFeeType: isFieldApplicable(performanceFeeApplicable)
              ? performanceFeeType
              : null,
            maxPerformanceFee: isFieldVariable(performanceFeeType, performanceFeeApplicable)
              ? maxPerformanceFee
              : null,
            minPerformanceFee: isFieldVariable(performanceFeeType, performanceFeeApplicable)
              ? minPerformanceFee
              : null,
          }) as unknown as ClassPlanProps
        );
      }
      history.push(fundId ? 'fund-details' : 'fund-list', { fundId: fundId });
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <>
      <Formik
        initialValues={editField}
        onSubmit={onSubmit}
        enableReinitialize={true}
        validate={(values: addFundPlanType) => {
          try {
            validateYupSchema(
              values,
              fundId ? editFundValidation : addFundValidation,
              true,
              values
            );
          } catch (e) {
            return yupToFormErrors(e);
          }
        }}>
        {({ handleSubmit, values, setValues }) => (
          <Box sx={styles.UsersFormikBox} component="form" noValidate onSubmit={handleSubmit}>
            <Hidden smUp={true}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    history.push(fundId ? 'fund-details' : 'fund-list', { fundId: fundId })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    color: '#1C2D47',
                  }}>
                  Back
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  my: 2,
                  py: 2,
                  pl: { xs: 3, sm: 0 },
                  color: 'primary.main',
                  bgcolor: 'rgba(238, 244, 251, 0.5)',
                }}>
                <PersonOutlineOutlinedIcon fontSize="large" />
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    pl: 1,
                  }}>
                  Fund Setup
                </Typography>
              </Box>
            </Hidden>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Hidden only="xs">
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    history.push(fundId ? 'fund-details' : 'fund-list', { fundId: fundId })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
              </Hidden>
              <Typography
                sx={{
                  fontSize: 20,
                  fontWeight: 600,
                  color: '#1C2D47',
                  pl: { xs: 3, sm: 0 },
                }}>
                {fundId ? 'Edit Fund' : 'Add Fund'}
              </Typography>
            </Box>
            {loading ? (
              <LinearProgress sx={{ mt: 2 }} />
            ) : (
              <>
                <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                  <SubHeading
                    sx={{
                      color: 'common.blue',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                      ml: { xs: 3.5 },
                      // backgroundColor: 'red',
                    }}>
                    {'Fund Details(Scheme)'}
                  </SubHeading>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="schemeCode"
                      label="Scheme Code *"
                      placeholder="Enter Scheme Code"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="schemeName"
                      label="Scheme Name *"
                      placeholder="Enter Scheme Name"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField name="amcCode" label="AMC Code" placeholder="Enter AMC Code" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField name="bankName" label="Bank Name" placeholder="Enter Bank Name" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="bankBranch"
                      label="Bank Branch"
                      placeholder="Enter Bank Branch"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField name="ifscCode" label="IFSC Code" placeholder="Enter IFSC Code" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="bankAccountNumber"
                      label="Bank Account Number"
                      placeholder="Enter Bank Account Number"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="LEEGALITY_STAMP_SERIES"
                      label="Stamp Paper Series *"
                      placeholder="Enter Stamp Paper Series"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="LEEGALITY_STAMP_SERIES_GROUP"
                      label="Stamp Paper Group *"
                      placeholder="Enter Stamp Paper Group"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="LEEGALITY_STAMP_VALUE"
                      label="Stamp Paper Value *"
                      placeholder="Enter Stamp Paper Value"
                      type="number"
                      onKeyDown={(e) => {
                        allowOnlyNumbers(e);
                      }}
                      trimOnBlur={false}
                    />
                  </Grid>
                  {/* <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}>
                    <UseRadioGroup
                      name={`LEEGALITY_USE_STAMP_SERIES`}
                      formLabel="Is Stamp Paper Series *"
                      items={Object.keys(IS_STAMP_PAPER_SERIES_MASTER).map((item) => ({
                        label: IS_STAMP_PAPER_SERIES_MASTER[item],
                        value: item,
                      }))}
                      value={values.LEEGALITY_USE_STAMP_SERIES?.toString()}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6} md={4}>
                    <MultipleSelect
                      name={`modeOfInvestment`}
                      label="Investment Methods *"
                      items={
                        Object.keys(INVESTMENT_METHOD_MASTER).map((ele) => ({
                          key: ele,
                          value: INVESTMENT_METHOD_MASTER[ele],
                        })) || []
                      }
                      renderText="Selected Investment Methods"
                    />
                  </Grid>
                </Grid>
                {checkDrawdown(values.modeOfInvestment) && (
                  <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                    <InvestmentCategoryHeading text="Drawdown Details" />
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="drawdownDetails.percentage"
                        label="Percentage *"
                        placeholder="Enter Percentage"
                      />
                    </Grid>
                  </Grid>
                )}
                {checkSip(values.modeOfInvestment) && (
                  <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                    <InvestmentCategoryHeading text="Sip Details" />
                    {/* <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="sipDetails.percentage"
                        label="Percentage *"
                        placeholder="Enter Percentage"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="sipDetails.months"
                        label="Months *"
                        placeholder="Enter Months"
                      />
                    </Grid> */}
                    <SIPDetails setValues={setValues} values={values} />
                  </Grid>
                )}
                {checkLumpsum(values.modeOfInvestment) && (
                  <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                    <InvestmentCategoryHeading text="Lumpsum Details" />
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="lumpsumDetails.percentage"
                        label="Percentage *"
                        placeholder="Enter Percentage"
                        disabled={true}
                      />
                    </Grid>
                  </Grid>
                )}

                {!fundId && (
                  <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                    <SubHeading
                      sx={{
                        color: 'common.blue',
                        letterSpacing: 0.5 + 'px',
                        padding: { xs: '10px 10px', sm: '10px 30px' },
                        ml: { xs: 3.5 },
                      }}>
                      {'Plan Details'}
                    </SubHeading>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="planCode"
                        label="Plan Code *"
                        placeholder="Enter Plan Code"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="planDescription"
                        label="Plan Description *"
                        placeholder="Enter Plan Description"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="schemeNature"
                        label="Scheme Nature *"
                        placeholder="Enter Scheme Nature"
                      />
                    </Grid>
                    {/* <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="registrationNumber"
                        label="Registration Number *"
                        placeholder="Enter Registration Number"
                      />
                    </Grid> */}
                    <Grid item xs={12} sm={6} md={4}>
                      <MFSelectField
                        name="fundManagerId"
                        label="Investment Manager Name *"
                        items={fundManager.map((item) => ({
                          key: item.name,
                          value: item.id,
                        }))}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFSelectField
                        name="trusteeId"
                        label="Trustee Name *"
                        items={trustee.map((item) => ({
                          key: item.name,
                          value: item.id,
                        }))}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="schemeCategory"
                        label="Scheme Category *"
                        placeholder="Enter Scheme Category"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField name="country" label="Country" placeholder="Enter Country" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFSelectField
                        name="currency"
                        label="Currency"
                        items={Object.keys(CurrencyMaster).map((item) => ({
                          key: CurrencyMaster[item].currency,
                          value: item,
                        }))}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <DatePicker
                        label={'Scheme Start Date'}
                        inputLabelStyles={{
                          transform: 'unset',
                          fontSize: 14,
                          fontWeight: 500,

                          color: 'rgba(0,0,0,0.7)',
                        }}
                        placeholder={'Enter Scheme Start Date'}
                        name={`schemeStartDate`}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="lockInPeriod"
                        label="Lock In Period(In Year)"
                        placeholder="Enter Lock In Period(In Year)"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="lockInExtension"
                        label="Lock In Extension(In Year)"
                        placeholder="Enter Lock In Extension(In Year)"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="faceValue"
                        label="Face value"
                        placeholder="Enter Face value"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="fundAddress1"
                        label="Fund Address 1"
                        placeholder="Enter Fund Address 1"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="fundAddress2"
                        label="Fund Address 2"
                        placeholder="Enter Fund Address 2"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="fundAddress3"
                        label="Fund Address 3"
                        placeholder="Enter Fund Address 3"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="custodian"
                        label="Custodian"
                        placeholder="Enter Custodian"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="setupFee"
                        label="Setup Fee"
                        placeholder="Enter Setup Fee"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="minCommitmentAmount"
                        label="Minimum Commitment Amount *"
                        placeholder="Enter Minimum Commitment Amount"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                      {values.minCommitmentAmount != 0 && (
                        <Typography sx={{ fontSize: 13 }}>
                          {currencyConversion(values.minCommitmentAmount, values.currency)}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="maxCommitmentAmount"
                        label="Maximum Commitment Amount *"
                        placeholder="Enter Maximum Commitment Amount"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                      {values.maxCommitmentAmount != 0 && (
                        <Typography sx={{ fontSize: 13 }}>
                          {currencyConversion(values.maxCommitmentAmount, values.currency)}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="minContributionPercentage"
                        label="Minimum Contribution Percentage"
                        placeholder="Enter Minimum Contribution Percentage"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="managementFee"
                        label="Management Fee"
                        placeholder="Enter Management Fee"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="tcLink"
                        label={`T&C Link`}
                        placeholder={`Enter T&C Link`}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFSelectField
                        name="planClass"
                        label="Fee Structure*"
                        items={[
                          { key: 'A', value: 'A' },
                          { key: 'B', value: 'B' },
                          { key: 'C', value: 'C' },
                          { key: 'D', value: 'D' },
                        ]}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="classOfUnits"
                        label={`Class of Units *`}
                        placeholder={`Enter class of units`}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <UseRadioGroup
                        formLabel="Hurdle Rate Applicable *"
                        name={`hurdleRateApplicable`}
                        items={Object.keys(YES_NO_MASTER).map((item) => ({
                          label: YES_NO_MASTER[item],
                          value: item,
                        }))}
                      />
                    </Grid>
                    {isFieldApplicable(values.hurdleRateApplicable) && (
                      <>
                        <Grid item xs={12} sm={6} md={4}>
                          <UseRadioGroup
                            formLabel="Hurdle Rate Type *"
                            name={`hurdleRateType`}
                            items={Object.keys(FEE_TYPE_MASTER).map((item) => ({
                              label: FEE_TYPE_MASTER[item],
                              value: item,
                            }))}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField
                            name="defaultHurdleRate"
                            label="Hurdle Rate % *"
                            placeholder="Enter Hurdle Rate"
                            type="number"
                            onKeyDown={(e) => {
                              allowOnlyNumbers(e);
                            }}
                            trimOnBlur={false}
                          />
                        </Grid>
                      </>
                    )}
                    {isFieldVariable(values.hurdleRateType, values.hurdleRateApplicable) && (
                      <>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField
                            name="minHurdleRate"
                            label="Minimum Hurdle Rate % *"
                            placeholder="Enter Minimum Hurdle Rate"
                            type="number"
                            onKeyDown={(e) => {
                              allowOnlyNumbers(e);
                            }}
                            trimOnBlur={false}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField
                            name="maxHurdleRate"
                            label="Maximum Hurdle Rate % *"
                            placeholder="Enter Maximum Hurdle Rate"
                            type="number"
                            onKeyDown={(e) => {
                              allowOnlyNumbers(e);
                            }}
                            trimOnBlur={false}
                          />
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12} sm={6} md={4}>
                      <UseRadioGroup
                        formLabel="Performance Fee Applicable *"
                        name={`performanceFeeApplicable`}
                        items={Object.keys(YES_NO_MASTER).map((item) => ({
                          label: YES_NO_MASTER[item],
                          value: item,
                        }))}
                      />
                    </Grid>
                    {isFieldApplicable(values.performanceFeeApplicable) && (
                      <>
                        <Grid item xs={12} sm={6} md={4}>
                          <UseRadioGroup
                            formLabel="Performance Fee Type *"
                            name={`performanceFeeType`}
                            items={Object.keys(FEE_TYPE_MASTER).map((item) => ({
                              label: FEE_TYPE_MASTER[item],
                              value: item,
                            }))}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField
                            name="defaultPerformanceFee"
                            label="Performance Fee % *"
                            placeholder="Enter Performance Fee"
                            type="number"
                            onKeyDown={(e) => {
                              allowOnlyNumbers(e);
                            }}
                            trimOnBlur={false}
                          />
                        </Grid>
                      </>
                    )}
                    {isFieldVariable(
                      values.performanceFeeType,
                      values.performanceFeeApplicable
                    ) && (
                      <>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField
                            name="minPerformanceFee"
                            label="Minimum Performance Fee % *"
                            placeholder="Enter Minimum Performance Fee"
                            type="number"
                            onKeyDown={(e) => {
                              allowOnlyNumbers(e);
                            }}
                            trimOnBlur={false}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField
                            name="maxPerformanceFee"
                            label="Maximum Performance Fee % *"
                            placeholder="Enter Maximum Performance Fee"
                            type="number"
                            onKeyDown={(e) => {
                              allowOnlyNumbers(e);
                            }}
                            trimOnBlur={false}
                          />
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12} sm={6} md={4}>
                      <Box sx={{ display: 'flex' }}>
                        <MFCheckbox name={`isApplicableForDirect`} label="Direct" />
                        <MFCheckbox name={`isApplicableForDistributor`} label="Distributor" />
                      </Box>
                    </Grid>
                  </Grid>
                )}
                {access && (
                  <Box sx={{ width: '100%', maxWidth: '350px', mx: 'auto', mt: 3 }}>
                    <MFSubmitButton label="Save" />
                  </Box>
                )}
              </>
            )}
          </Box>
        )}
      </Formik>
    </>
  );
}
